const PREFIX = 'NEXT_PRIORITY';

export const LEAD_NEXT_PRIORITY = `${PREFIX}/LEAD`;
export const WORK_NEXT_PRIORITY = `${PREFIX}/WORK`;
export const MODAL_END_WAIT_LIST_NEXT_PRIORITY = `${PREFIX}/MODAL_END_WAIT_LIST`;
export const RESTART_NEXT_PRIORITY = `${PREFIX}/RESTART`;
